(function () {
    'use strict';

    /// Usando prototype creo una función que me convierte mi fecha String en un objeto Date para se consumido por javascript
    String.prototype.toDate = function (format) {
        switch(format) {
            case 'dd/MM/yyyy':
                return new Date(parseInt(this.split('/')[2]), parseInt(this.split('/')[1]) - 1, parseInt(this.split('/')[0]));
                break;
            case 'dd/MM/yyyy HH:mm':
                return new Date(parseInt(this.split('/')[2]), parseInt(this.split('/')[1]) - 1, parseInt(this.split('/')[0]), parseInt((this.split(' ')[1]).split(':')[0]), parseInt((this.split(' ')[1]).split(':')[1]));
                break;
            case 'HH:mm':
                return new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate(), parseInt(this.split(':')[0]), parseInt(this.split(':')[1]));
                break;
            default:
                return new Date(parseInt(this.split('/')[2]), parseInt(this.split('/')[1]) - 1, parseInt(this.split('/')[0]));
                break;
        }
    };

    /// Usando prototype creo una función que me convierte mi fecha Date en un objeto String para se consumido por el servicio
    Date.prototype.toString = function (format) {
        switch (format) {
            case 'dd/MM/yyyy':
                return this.getDate() + '/' + (this.getMonth() + 1) + '/' + this.getFullYear();
                break;
            case 'dd/MM/yyyy HH:mm':
                return this.getDate() + '/' + (this.getMonth() + 1) + '/' + this.getFullYear() + ' ' + this.getHours() + ':' + this.getMinutes();
                break;
            case 'HH:mm':
                return this.getHours() + ':' + this.getMinutes();
                break;
            case 'dd/MM/yyyy HH:mm:ss':
                return this.getDate() + '/' + (this.getMonth() + 1) + '/' + this.getFullYear() + ' ' + this.getHours() + ':' + this.getMinutes() + ':' + this.getSeconds();
                break;
            default:
                return this.getDate() + '/' + (this.getMonth() + 1) + '/' + this.getFullYear() + ' ' + this.getHours() + ':' + this.getMinutes();
                break;
        }
    };

    /// Usando prototype creo una función que me devuelve la diferencia entre una fecha y otra enviada por parámetro
    Date.prototype.dateDiff = function (format, dateToCompare) {

        var dateDiff = this > dateToCompare ? this - dateToCompare : dateToCompare - this;

        switch (format) {
            case 'minute':
                return Math.floor((dateDiff / 1000) / 60);
                break;
            case 'hour':
                return Math.floor((dateDiff % 86400000) / 3600000);
                break;
            case 'day':
                return Math.floor(dateDiff / 86400000);
                break;
            default:
                return Math.floor(dateDiff);
                break;
        }
    };

    /// Función para agregar tiempo a un date
    Date.prototype.dateAdd = function (format, value) {
        switch (format) {
            case 'minute':
                this.setTime(this.getTime() + value * 60000);
                break;
            case 'hour':
                this.setTime(this.getTime() + (value * 60 * 60 * 1000));
                break;
            case 'day':
                this.setTime(this.getTime() + (value * 86400000));
                break;
            default:
                this.setTime(this.getTime() + value * 60000);
                break;
        }
        return this;
    };

    /// Función para convertir un número en a formato HH:mm, para indicar el tiempo en horas y minutos
    Number.prototype.toTime = function () {
        var hrs = Math.floor(this)
        var min = Math.round(this % 1 * 60)
        min = min < 10 ? "0" + min : min.toString();
        return hrs + ":" + min;
    };

    Number.prototype.isInteger = function () {
    	return (this ^ 0) === +this;
    }

    /// Función para convertir un booleano a número (0/1)
    Boolean.prototype.toNumber = function () {
        return this ? 1 : 0;
    };

    Date.prototype.getWeek = function () {
        var onejan = new Date(this.getFullYear(), 0, 1);
        return Math.ceil((((this - onejan) / 86400000) + onejan.getDay() + 1) / 7);
    };

})();


// WEBPACK FOOTER //
// ./app/prototype.js